export default {
  FETCHED_LATEST: 'FETCHED_ACCOUNT_PNL_LATEST',
  FETCHED_HISTORY: 'FETCHED_ACCOUNT_PNL_HISTORY',
};
